import { render, staticRenderFns } from "./CardFormView.vue?vue&type=template&id=bfd341d8&scoped=true&"
import script from "./CardFormView.vue?vue&type=script&lang=js&"
export * from "./CardFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd341d8",
  null
  
)

export default component.exports